import { type ComponentPropsWithoutRef, forwardRef } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { useSplitButtonContext } from "./SplitButtonContext";
import { splitButtonVariants } from "./splitButtonVariants";

export type SplitButtonActionProps = ComponentPropsWithoutRef<"button"> & {
  "data-testid"?: string;
};

export const SplitButtonAction = forwardRef<
  HTMLButtonElement,
  SplitButtonActionProps
>(({ children, className, disabled, ...props }, ref) => {
  const { variant } = useSplitButtonContext();
  const { ["data-testid"]: dataTestId, ...restProps } = props;

  return (
    <button
      className={cnTwMerge(
        splitButtonVariants({ variant }),
        "px-5",
        {
          "cursor-not-allowed select-none user-select-none": disabled,
        },
        className,
      )}
      data-testid={dataTestId ?? "split-button-action"}
      disabled={disabled}
      ref={ref}
      type="button"
      {...restProps}
    >
      <span className="flex items-center gap-2">{children}</span>
    </button>
  );
});
